var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _class2, _descriptor, _descriptor2, _descriptor3;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Component, Prop, CustomElement, html, Event } from '@sick-davinci/ce-decorators';
import { style } from './Callout.style';
import { icon_check_circle } from '@sick-davinci/material-icons/action/check_circle.icon';
import { icon_error } from '@sick-davinci/material-icons/alert/error.icon';
import { icon_info } from '@sick-davinci/material-icons/action/info.icon';
import { icon_warning } from '@sick-davinci/material-icons/alert/warning.icon';
import { icon_close } from '@sick-davinci/material-icons/navigation/close.icon';
import { IconRef } from '../icon/IconRef';
const ICON = {
  success: icon_check_circle,
  error: icon_error,
  warning: icon_warning,
  info: icon_info,
  close: icon_close
};
/**
 * A `davinci-callout` is used to inform the user.
 * It shows information in different visual styles (aka *types*).
 * 
 * @example
 * ```html
 *  <davinci-callout>
 *    I am a useful information!
 *  </davinci-callout>
 *  
 *  <davinci-callout type="success">
 *    <em>Whoooohoo!</em> you got it!
 *  </davinci-callout>
 *  ```
 * @slot {*} content
 */

export let Callout = (_dec = Component({
  tag: 'davinci-callout',
  style: [style],
  dependencies: [IconRef]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop({
  reflectAsAttribute: false
}), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Event({
  name: 'remove'
}), _dec7 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class Callout extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "type", _descriptor, this);

    _initializerDefineProperty(this, "closeable", _descriptor2, this);

    _initializerDefineProperty(this, "close", _descriptor3, this);

    this._onKeyDown = event => {
      if (event.key === 'Enter' || event.key === 'Delete' || event.key === ' ') {
        this._closeCallout();
      }
    };
  }

  render() {
    const {
      type
    } = this;
    return html`
      <div class=${`container ${type}`}>
        <davinci-icon-ref class="icon" .src="${ICON[type]}"></davinci-icon-ref>
        <div class=text>
          <slot></slot>
        </div>
        ${this.closeable ? this.renderClose() : ``}
      </div>
    `;
  }
  /*tslint:disable*/


  renderClose() {
    return html`
      <davinci-icon-ref .src="${ICON['close']}"
                        class="close"
                        tabindex="0"
                        @click="${this._closeCallout}"
                        @keydown="${this._onKeyDown}">
      </davinci-icon-ref>
    `;
  }
  /*tslint:enable*/


  _closeCallout() {
    this.close.emit(this);
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'info';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "closeable", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "close", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
